import { useEffect } from 'react';
import ModernChatDialog from './ModernChatDialog';
import { useModernChatStore } from '../../../stores/modern-chat-store';
import BroccoliCharacter from '../../../assets/broccoli_character.png';


interface ModernChatProps {
  playbookId: string;
  playbookName?: string;
}

export default function ModernChat({ playbookId, playbookName }: ModernChatProps) {
  const clearChatMessages = useModernChatStore((state) => state.clearChatMessages);

  useEffect(() => {
    clearChatMessages();
  }, [clearChatMessages]);

  return (
    <div className="flex flex-col h-screen bg-gradient-to-br from-gray-50 via-white to-gray-50">
      {/* Chat Container */}
      <div className="flex-1 flex relative overflow-hidden">
        <ModernChatDialog />
      </div>
    </div>
  );
} 